<template>
  <div class="tab-content">
    <div class="pagenamPT">
      <h3 class="pagename2">{{ $t('front.common.betStatus') }}({{ statTypeStr }})</h3>
    </div>
    <div class="partnerTop">
      <div></div>
      <div class="fx-center-end">
        <select class="selectBox" v-model="searchType">
          <option :value="'id'">{{ $t('front.common.memId') }}</option>
          <option :value="'nickname'">{{ $t('front.common.nickName') }}</option>
        </select>
        <input type="text" class="input" v-model="searchValue"/>
        <date-filter-Pt @search="onSearch" :startDate="startDate" :endDate="endDate" @update="updateDate" />
      </div>
      <!-- <date-filter-Pt :startDate="startDate"
                      :endDate="endDate"
                      @update="updateDate"
                      @search="onSearch" /> -->
    </div>
    <!-- 모바일용 트리구조 -->
    <div class="betTreeMobileBtn" @click="betTreeOpen = !betTreeOpen">
      전체 파트너 목록 보기
    </div>
    <div class="betTreeDropdown" v-show="betTreeOpen">
      <PartnerHierarchy @onClickMemId="onClickBetTree"></PartnerHierarchy>
    </div>
    <div class="strTableWrap">
      <!-- PC용 트리 -->
      <div class="betTreePc">
        <PartnerHierarchy @onClickMemId="loadSubList"></PartnerHierarchy>
      </div>

      <div class="strTablescr">
        <h2 class="betTitle">{{ $t('front.common.partnerBet') }} & {{ $t('front.common.rollData') }}</h2>
        <div class="strTablePC mb40">
          <table class="strTablePT">
            <thead>
              <tr>
                <th>{{ $t('front.board.type') }}</th>
                <th>{{ $t('front.common.memId') }}<br>{{ $t('front.common.nickName') }}</th>
                <th>{{ $t('front.common.partnerCharge') }}</th>
                <th>{{ $t('front.common.partnerExchange') }}</th>
                <th>{{ $t('front.common.totalBetting') }}</th>
                <th>{{ $t('front.common.totalWin') }}</th>
                <th>{{ $t('front.stributor.allBet') }}-{{ $t('front.stributor.allWin') }}</th>
                <th>{{ $t('front.common.totalRoll') }}</th>
                <th>{{ $t('front.common.betProLoss') }}</th>
                <th>{{ $t('front.common.totalLosing') }}</th>
                <th>{{ $t('front.stributor.lose') }}%</th>
                <th>{{ $t('front.cash.coupon') }}</th>
                <th>{{ $t('front.cash.nav3') }}</th>
                <th>{{ $t('front.common.haveRolling') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="myStatData">
                <td>{{ myStatData.partnerLevelName }}</td>
                <td>{{ myStatData.memId }}<br><em class="nick">{{ myStatData.memNick }}</em></td>
                <td class="text-right">{{ thousand(myStatData.cashInAmtSum || 0) }}</td>
                <td class="text-right">{{ thousand(myStatData.cashOutAmtSum || 0) }}</td>
                <td>{{ thousand(myStatData.betAmtSum || 0) }}</td>
                <td>{{ thousand(myStatData.winAmtSum || 0) }}</td>
                <td>{{ thousand(myStatData.winLoseSum || 0) }}</td>
                <td>{{ thousand(myStatData.rollingSum || 0) }}</td>
                <td>{{ thousand(myStatData.totalBEP || 0) }}</td>
                <td>{{ thousand(myStatData.losingAmtSum || 0) }}</td>
                <td>{{ thousand(myStatData.loseRate || 0) }}</td>
                <td>{{ thousand(myStatData.couponCashSum || 0) }}</td>
                <td>{{ thousand(myStatData.cashAmtSum || 0) }}</td>
                <td>{{ thousand(myStatData.pointAmtSum || 0) }}</td>
              </tr>
              <tr v-else>
                <td colspan="11">{{ $t('front.common.notFoundList') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="strTablePC">
          <h2 class="betTitle">{{ $t('front.common.lowPartnerBet') }} & {{ $t('front.common.rollData') }}</h2>
          <table class="strTablePT">
            <thead>
              <tr>
                <th>{{ $t('front.board.type') }}</th>
                <th>{{ $t('front.common.memId') }}<br>{{ $t('front.common.nickName') }}</th>
                <th>{{ $t('front.common.partnerCharge') }}</th>
                <th>{{ $t('front.common.partnerExchange') }}</th>
                <th>{{ $t('front.common.totalBetting') }}</th>
                <th>{{ $t('front.common.totalWin') }}</th>
                <th>{{ $t('front.stributor.allBet') }}-{{ $t('front.stributor.allWin') }}</th>
                <th>{{ $t('front.common.totalRoll') }}</th>
                <th>{{ $t('front.common.betProLoss') }}</th>
                <th>{{ $t('front.common.totalLosing') }}</th>
                <th>{{ $t('front.stributor.lose') }}%</th>
                <th>{{ $t('front.cash.coupon') }}</th>
                <th>{{ $t('front.cash.nav3') }}</th>
                <th>{{ $t('front.common.haveRolling') }}</th>
              </tr>
            </thead>
            <tbody v-if="botStatList && botStatList.length > 0">
              <tr v-for="item in botStatList" :key="item.memId">
                <td>{{ item.partnerLevelName }}</td>
                <td>{{ item.memId }}<br><em class="nick">{{ item.memNick }}</em></td>
                <td class="text-right">{{ thousand(item.cashInAmtSum || 0) }}</td>
                <td class="text-right">{{ thousand(item.cashOutAmtSum || 0) }}</td>
                <td>{{ thousand(item.betAmtSum || 0) }}</td>
                <td>{{ thousand(item.winAmtSum || 0) }}</td>
                <td>{{ thousand(item.winLoseSum || 0) }}</td>
                <td>{{ thousand(item.rollingSum || 0) }}</td>
                <td>{{ thousand(item.totalBEP || 0) }}</td>
                <td>{{ thousand(item.losingAmtSum || 0) }}</td>
                <td>{{ thousand(item.loseRate || 0) }}</td>
                <td>{{ thousand(item.couponCashSum || 0) }}</td>
                <td>{{ thousand(item.cashAmtSum || 0) }}</td>
                <td>{{ thousand(item.pointAmtSum || 0) }}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr><td colspan="11">{{ $t('front.common.notFoundList') }}</td></tr>
            </tbody>
            <tfoot v-if="botStatSum">
              <tr>
                <td>합계</td>
                <td></td>
                <td class="text-right">{{ thousand(botStatSum.cashInAmtSum || 0) }}</td>
                <td class="text-right">{{ thousand(botStatSum.cashOutAmtSum || 0) }}</td>
                <td>{{ thousand(botStatSum.betAmtSum || 0) }}</td>
                <td>{{ thousand(botStatSum.winAmtSum || 0) }}</td>
                <td>{{ thousand(botStatSum.winLoseSum || 0) }}</td>
                <td>{{ thousand(botStatSum.rollingSum || 0) }}</td>
                <td>{{ thousand(botStatSum.totalBEP || 0) }}</td>
                <td>{{ thousand(botStatSum.losingAmtSum || 0) }}</td>
                <td>{{ thousand(botStatSum.loseRate || 0) }}</td>
                <td>{{ thousand(botStatSum.couponCashSum || 0) }}</td>
                <td>{{ thousand(botStatSum.cashAmtSum || 0) }}</td>
                <td>{{ thousand(botStatSum.pointAmtSum || 0) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="betStatMobile">
          <section class="betStatCard" v-if="myStatData">
            <h4>{{ $t('front.common.partnerBet') }} & {{ $t('front.common.rollData') }}</h4>
            <div class="cardHead">
              <strong>{{ myStatData.memId }}</strong>
              <span>{{ myStatData.memNick }}</span>
              <em>{{ myStatData.partnerLevelName }}</em>
            </div>

            <div class="cardGrid">
              <div><span>파트너 총충전</span><strong>{{ thousand(myStatData.cashInAmtSum || 0) }}</strong></div>
              <div><span>파트너 총환전</span><strong>{{ thousand(myStatData.cashOutAmtSum || 0) }}</strong></div>
              <div><span>총 베팅금</span><strong>{{ thousand(myStatData.betAmtSum || 0) }}</strong></div>
              <div><span>총 당첨금</span><strong>{{ thousand(myStatData.winAmtSum || 0) }}</strong></div>
              <div><span>총베팅-총당첨</span><strong>{{ thousand(myStatData.winLoseSum || 0) }}</strong></div>
              <div><span>총 롤링금</span><strong>{{ thousand(myStatData.rollingSum || 0) }}</strong></div>
              <div><span>베팅손익</span><strong>{{ thousand(myStatData.totalBEP || 0) }}</strong></div>
              <div><span>총 루징금</span><strong>{{ thousand(myStatData.losingAmtSum || 0) }}</strong></div>
              <div><span>루징%</span><strong>{{ thousand(myStatData.loseRate || 0) }}</strong></div>
              <div><span>쿠폰</span><strong>{{ thousand(myStatData.couponCashSum || 0) }}</strong></div>
              <div><span>보유머니</span><strong>{{ thousand(myStatData.cashAmtSum || 0) }}</strong></div>
              <div><span>보유롤링금</span><strong>{{ thousand(myStatData.pointAmtSum || 0) }}</strong></div>
            </div>
          </section>

          <section class="betStatCard">
            <h4>{{ $t('front.common.lowPartnerBet') }} & {{ $t('front.common.rollData') }}</h4>

            <template v-if="botStatList && botStatList.length > 0">
              <div class="miniCard" v-for="item in botStatList" :key="item.memId">
                <div class="cardHead">
                  <strong>{{ item.memId }}</strong>
                  <span>{{ item.memNick }}</span>
                  <em>{{ item.partnerLevelName }}</em>
                </div>

                <div class="cardGrid">
                  <div><span>파트너 총충전</span><strong>{{ thousand(item.cashInAmtSum || 0) }}</strong></div>
                  <div><span>파트너 총환전</span><strong>{{ thousand(item.cashOutAmtSum || 0) }}</strong></div>
                  <div><span>총 베팅금</span><strong>{{ thousand(item.betAmtSum || 0) }}</strong></div>
                  <div><span>총 당첨금</span><strong>{{ thousand(item.winAmtSum || 0) }}</strong></div>
                  <div><span>총베팅-총당첨</span><strong>{{ thousand(item.winLoseSum || 0) }}</strong></div>
                  <div><span>총 롤링금</span><strong>{{ thousand(item.rollingSum || 0) }}</strong></div>
                  <div><span>베팅손익</span><strong>{{ thousand(item.totalBEP || 0) }}</strong></div>
                  <div><span>총 루징금</span><strong>{{ thousand(item.losingAmtSum || 0) }}</strong></div>
                  <div><span>루징%</span><strong>{{ thousand(item.loseRate || 0) }}</strong></div>
                  <div><span>쿠폰</span><strong>{{ thousand(item.couponCashSum || 0) }}</strong></div>
                  <div><span>보유머니</span><strong>{{ thousand(item.cashAmtSum || 0) }}</strong></div>
                  <div><span>보유롤링금</span><strong>{{ thousand(item.pointAmtSum || 0) }}</strong></div>
                </div>
              </div>
            </template>

            <div class="emptyCard" v-else>
              {{ $t('front.common.notFoundList') }}
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DateFilterPt from '@/components/ui/DateFilterPt'
import PartnerHierarchy from '@/components/common/mobile/PartnerHierarchy.vue'
import { getDateStr, thousand } from '@/libs/utils'
import { addDays } from 'date-fns'
import { getBettingListV2 } from '@/api/v2/betting'
// import { getBettingListV2, getBettingDetail } from '@/api/v2/betting'
import { mapState } from 'vuex'
export default {
  name: 'betAll',
  components: { PartnerHierarchy, DateFilterPt },
  computed: {
    ...mapState([
      'userData',
      'gameCount',
      'commonCodeByOrder',
      'commonCodeByCode'
    ]),
    statTypeStr () {
      if (this.statType === 'total') {
        return '전체'
      } else if (this.statType === 'casino') {
        return '카지노'
      } else if (this.statType === 'slot') {
        return '슬롯'
      }

      return ''
    }
  },
  data () {
    return {
      betTreeOpen: false,
      searchType: 'id',
      searchValue: '',
      reqData: {
        memId: ''
      },
      statType: 'total',
      startDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 00:00:00'),
      endDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 23:59:59'),
      myStatData: null,
      botStatList: null,
      botStatSum: null,
      selectMemId: null
    }
  },
  created () {
    this.emitter.emit('Loading', true)
    console.log(this.$route.name)
    const name = this.$route.name
    this.statType = name.replace('betting', '')

    this.loadSubList(this.userData.memId, 'main', 1)
    this.emitter.emit('Loading', false)
  },
  methods: {
    thousand,
    onClickBetTree (memId, type, item) {
      this.loadSubList(memId, type, 1)

      if (window.innerWidth <= 1000) {
        this.betTreeOpen = false
      }
    },
    updateDate (value) {
      this.startDate = value.startDate
      this.endDate = value.endDate
    },
    onSearch () {
      this.loadSubList(this.selectMemId)
    },
    loadSubList (memId, type, page) {
      this.emitter.emit('Loading', true)
      if (!memId) {
        memId = this.selectMemId
      } else {
        this.selectMemId = memId
      }
      if (!page) {
        page = this.pageInfo.page
      } else {
        this.pageInfo.page = page
      }

      const params = {
        memId,
        statType: this.statType,
        startDate: this.startDate,
        endDate: this.endDate,
        searchValue: this.searchValue
      }

      getBettingListV2(params).then(res => {
        this.myStatData = null
        this.botStatList = null
        this.botStatSum = null
        const result = res.data
        if (result.resultCode === '0') {
          this.myStatData = result.data.myStatData
          this.botStatList = result.data.botStatList
          this.botStatSum = result.data.botStatSum
        }

        this.emitter.emit('Loading', false)
      })
    }
  }
}
</script>

<style scoped>
.flex-c {
  flex-direction: column;
}
.gap-2 {
  gap: 2px;
}

.tab-content {
  color: #1d2939;
}

.pagenamPT {
  margin-bottom: 18px;
}

.pagename2 {
  color: #101828;
  font-size: 20px;
  font-weight: 800;
}

.partnerTop {
  min-height: 70px;
  margin-bottom: 16px;
  padding: 18px 20px;
  border: 1px solid #dbe3ef;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}

.fx-center-end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
}

.selectBox,
.input {
  height: 34px !important;
  border: 1px solid #d7e0ec !important;
  border-radius: 6px !important;
  background-color: #f8fafc !important;
  color: #344054 !important;
  font-size: 13px !important;
  box-sizing: border-box;
  outline: none;
  margin: 0 !important;
}

.selectBox {
  min-width: 112px;
  padding: 0 10px !important;
}

.input {
  width: 300px;
  padding: 0 12px !important;
}

.selectBox:focus,
.input:focus {
  border-color: #2f68e9 !important;
  background: #fff !important;
  box-shadow: 0 0 0 3px rgba(47, 104, 233, 0.12);
}

/* DateFilterPt 내부 요소 보정 */
.fx-center-end :deep(.datesearchPT),
.fx-center-end :deep(.datesearchPTWarp),
.fx-center-end :deep(.datesearch) {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 !important;
}

.fx-center-end :deep(input[type="date"]),
.fx-center-end :deep(input[type="text"]) {
  height: 34px !important;
  border: 1px solid #d7e0ec !important;
  border-radius: 6px !important;
  background: #f8fafc !important;
  color: #344054 !important;
  font-size: 13px !important;
  box-sizing: border-box;
}

.fx-center-end :deep(.dateBtn),
.fx-center-end :deep(.bga),
.fx-center-end :deep(button) {
  height: 34px !important;
  min-width: 54px;
  padding: 0 14px !important;
  border: 0 !important;
  border-radius: 6px !important;
  background: #2563eb !important;
  color: #fff !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.18);
}

.strTableWrap {
  display: flex;
  align-items: flex-start;
  gap: 18px;
  min-height: 400px;
}

.betTreePc {
  width: 240px !important;
  min-width: 240px !important;
  max-width: 240px !important;
  flex: 0 0 240px !important;
}

.betTreePc .subMemWrap {
  width: 100%;
  border: 1px solid #e3e8f0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(16, 24, 40, 0.04);
}

.strTablescr {
  flex: 1;
  min-width: 0;
  padding: 0 12px 22px;
  border: 1px solid #dbe3ef;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.05);
  overflow-x: auto;
  box-sizing: border-box;
}

.betTitle {
  margin: 0 -12px 0;
  padding: 16px 20px 13px;
  border-bottom: 2px solid #2563eb;
  color: #101828;
  font-size: 17px;
  font-weight: 800;
  line-height: 1.3;
}

.strTablePC {
  min-width: 100%;
}

.strTablePC.mb40 {
  margin-bottom: 28px;
}

.strTablePT {
  width: 100%;
  min-width: 1120px;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
}

.strTablePT th,
.strTablePT td {
  height: 43px;
  padding: 9px 8px;
  border-bottom: 1px solid #e5eaf2;
  text-align: center;
  vertical-align: middle;
  box-sizing: border-box;
  word-break: keep-all;
}

.strTablePT th {
  background: #f3f6fb;
  color: #344054;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.25;
  border-right: 1px solid #e5eaf2;
}

.strTablePT th:last-child {
  border-right: 0;
}

.strTablePT td {
  background: #fff;
  color: #1d2939;
  font-size: 13px;
  line-height: 1.35;
}

.strTablePT tbody tr:nth-child(even) td {
  background: #f8fafc;
}

.strTablePT tbody tr:hover td {
  background: #eef5ff;
}

.strTablePT tfoot td {
  background: #f1f5ff;
  color: #101828;
  font-weight: 800;
  border-top: 1px solid #cddaf7;
}

.nick {
  color: #ff7e00;
  font-style: normal;
  font-weight: 700;
}

.text-right {
  text-align: right !important;
}

.betTotal {
  display: flex;
  align-items: center;
  gap: 10px;
}

.betStatMobile {
  display: none;
}

.betTreeMobileBtn,
.betTreeDropdown {
  display: none;
}

@media (max-width: 1000px) {
  .partnerTop {
    display: block;
    min-height: 0;
    padding: 14px;
  }

  .partnerTop > div:first-child {
    display: none;
  }

  .fx-center-end {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 8px;
  }

  .fx-center-end .selectBox {
    width: 95px;
    flex: 0 0 95px;
    height: 38px !important;
    border-radius: 8px !important;
  }

  .fx-center-end .input {
    flex: 1;
    width: calc(100% - 103px);
    height: 38px !important;
    border-radius: 8px !important;
  }

  .fx-center-end :deep(.datesearchPT),
  .fx-center-end :deep(.datesearchPTWarp),
  .fx-center-end :deep(.datesearch) {
    width: 100%;
    display: flex;
    gap: 6px;
  }

  .fx-center-end :deep(input[type="date"]) {
    width: calc(50% - 28px);
    min-width: 0 !important;
    height: 38px !important;
    padding: 0 6px !important;
    font-size: 12px !important;
  }

  .fx-center-end :deep(.dateBtn),
  .fx-center-end :deep(.bga),
  .fx-center-end :deep(button) {
    width: 50px !important;
    min-width: 50px !important;
    height: 38px !important;
    margin-left: 0 !important;
    padding: 0 !important;
  }

  .strTableWrap {
    flex-direction: column;
    gap: 12px;
  }

  .betTreePc {
    display: none;
  }

  .betTreeMobileBtn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 42px;
    padding: 0 15px;
    margin-bottom: 6px;
    border-radius: 8px;
    background: #2563eb;
    color: #fff;
    font-size: 14px;
    font-weight: 800;
    cursor: pointer;
    box-shadow: 0 4px 10px rgba(37, 99, 235, 0.18);
  }

  .betTreeMobileBtn::after {
    content: '›';
    font-size: 22px;
  }

  .betTreeDropdown {
    display: block;
    width: 100%;
    max-height: 420px;
    margin-bottom: 15px;
    background: #fff;
    border: 1px solid #dbe3ef;
    border-radius: 0 0 10px 10px;
    overflow-y: auto;
    box-shadow: 0 4px 10px rgba(16, 24, 40, 0.08);
  }

  .betTreeDropdown .subMemWrap {
    width: 100%;
    box-shadow: none;
    border-radius: 0;
  }

  .strTablescr {
    width: 100%;
    padding: 0;
    background: transparent;
    border: 0;
    box-shadow: none;
    overflow: visible;
  }

  .strTablePC {
    display: none;
  }

  .betTitle {
    display: none;
  }

  .betStatMobile {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .betStatCard,
  .miniCard {
    background: #fff;
    border: 1px solid #dfe3ee;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(16, 24, 40, 0.05);
  }

  .betStatCard h4 {
    margin: 0;
    padding: 13px 14px;
    background: #f3f6fb;
    border-bottom: 1px solid #e3e8f0;
    font-size: 15px;
    font-weight: 800;
    color: #101828;
  }

  .miniCard {
    margin: 12px 10px 0;
  }

  .miniCard:last-child {
    margin-bottom: 12px;
  }

  .cardHead {
    display: flex;
    align-items: flex-start;
    gap: 4px;
    padding: 14px 15px;
    background: #f8fafc;
    border-bottom: 1px solid #e3e8f0;
  }

  .cardHead strong {
    font-size: 16px;
    color: #111827;
    line-height: 1.2;
  }

  .cardHead span {
    color: #ff7e00;
    font-size: 13px;
    font-weight: 800;
    line-height: 1.2;
  }

  .cardHead em {
    margin-left: auto;
    min-width: 42px;
    height: 24px;
    padding: 0 8px;
    border-radius: 12px;
    background: #2563eb;
    color: #fff;
    font-size: 11px;
    line-height: 24px;
    text-align: center;
  }

  .cardGrid {
    display: flex;
    flex-direction: column;
    padding: 8px 14px;
  }

  .cardGrid div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 42px;
    padding: 7px 0;
    border-bottom: 1px solid #eef0f5;
    box-sizing: border-box;
  }

  .cardGrid div:last-child {
    border-bottom: 0;
  }

  .cardGrid span {
    flex: 0 0 115px;
    color: #667085;
    font-size: 12px;
    font-weight: 700;
  }

  .cardGrid strong {
    flex: 1;
    text-align: right;
    color: #111827;
    font-size: 15px;
    font-weight: 800;
    word-break: break-all;
  }

  .emptyCard {
    margin: 10px;
    padding: 30px 10px;
    border: 1px solid #e3e8f0;
    border-radius: 10px;
    text-align: center;
    color: #667085;
    background: #fff;
  }
}
</style>

<style scoped>
@media (max-width: 1000px) {
  .strTablescr {
    width: 100%;
    padding: 0 0 18px !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    border: 1px solid #dbe3ef !important;
    border-radius: 10px !important;
    background: #fff !important;
    box-shadow: 0 8px 24px rgba(16, 24, 40, 0.05) !important;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-x: contain;
    scrollbar-width: thin;
    scrollbar-color: #aab4c2 #edf2f7;
  }

  .strTablescr::-webkit-scrollbar {
    display: block;
    height: 8px;
  }

  .strTablescr::-webkit-scrollbar-track {
    background: #edf2f7;
  }

  .strTablescr::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: #aab4c2;
  }

  /* 모바일 카드형은 숨기고, 기존 PC 테이블을 그대로 노출 */
  .betStatMobile {
    display: none !important;
  }

  .strTablePC,
  .strTablePC.mb40 {
    display: block !important;
    min-width: 1120px !important;
  }

  .strTablePC.mb40 {
    margin-bottom: 28px !important;
  }

  .betTitle {
    display: block !important;
    width: 1120px !important;
    margin: 0 !important;
    padding: 16px 20px 13px !important;
    box-sizing: border-box;
  }

  .strTablePT {
    display: table !important;
    width: 1120px !important;
    min-width: 1120px !important;
    table-layout: fixed !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
  }

  .strTablePT thead {
    display: table-header-group !important;
  }

  .strTablePT tbody,
  .strTablePT tfoot {
    display: table-row-group !important;
  }

  .strTablePT tr {
    display: table-row !important;
  }

  .strTablePT th,
  .strTablePT td {
    display: table-cell !important;
    width: auto !important;
    min-width: 0 !important;
    height: 43px !important;
    padding: 9px 8px !important;
    box-sizing: border-box !important;
    vertical-align: middle !important;
    white-space: normal !important;
  }
}
</style>
